import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import * as Device from 'react-device-detect';

import { LanguageItem, PrivacyPolicyItem, TermsOfServiceItem, RegisterSpotItem } from './Items';
interface PublicDrawerProps {
  handleCloseDrawer: () => void;
}

export function PublicDrawer(props: Readonly<PublicDrawerProps>) {
  const { handleCloseDrawer } = props;
  const theme = useTheme();
  const listItemColor = Device.isMobile ? 'primary' : 'secondary';

  return (
    <Box
      sx={{
        width: 300,
        color: theme.palette.text[listItemColor],
        '& .MuiListItemButton-root': {
          color: theme.palette.text[listItemColor],
          '& .MuiListItemIcon-root, & .MuiListItemText-root': {
            color: theme.palette.text[listItemColor],
          },
          '&:hover': {
            color: theme.palette.text.primary,
            '& .MuiListItemIcon-root, & .MuiListItemText-root': {
              color: theme.palette.text.primary,
            },
          },
        },
        '& .MuiDivider-root': {
          backgroundColor: theme.palette.grey[700],
        },
      }}
      role="presentation"
    >
      <List>
        <LanguageItem handleCloseDrawer={handleCloseDrawer} />
        <RegisterSpotItem handleCloseDrawer={handleCloseDrawer} />
        <Divider variant="middle" />
        <PrivacyPolicyItem handleCloseDrawer={handleCloseDrawer} />
        <TermsOfServiceItem handleCloseDrawer={handleCloseDrawer} />
      </List>
    </Box>
  );
}
